import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  AiChatMessage,
  AiPromptAudit,
  AiSuggestion,
} from '../models/ai-assistant.models';
import {
  AI_AUDIT_PROMPT,
  AI_RESPONSE_LIBRARY,
  AI_SEEDED_MESSAGES,
  AI_WELCOME_SUGGESTIONS,
} from '../mock-data/ai-assistant.mock';

@Injectable({ providedIn: 'root' })
export class AiAssistantMockService {
  private sequence = 0;

  getWelcomeSuggestions(): AiSuggestion[] {
    return AI_WELCOME_SUGGESTIONS;
  }

  getSeedMessages(): AiChatMessage[] {
    return AI_SEEDED_MESSAGES.map((message) => ({ ...message }));
  }

  submitQuery(query: string): Observable<AiChatMessage[]> {
    const userMessage: AiChatMessage = {
      id: this.nextId('user'),
      role: 'user',
      text: query,
      createdAt: new Date().toISOString(),
    };

    const assistantMessage: AiChatMessage = {
      id: this.nextId('assistant'),
      role: 'assistant',
      blocks: this.resolveBlocks(query),
      audit: this.createAudit(query),
      createdAt: new Date().toISOString(),
    };

    return of([userMessage, assistantMessage]);
  }

  private resolveBlocks(query: string): AiChatMessage['blocks'] {
    const normalized = query.toLowerCase();

    if (normalized.includes('deployed') && normalized.includes('status')) {
      return AI_RESPONSE_LIBRARY['deployed'];
    }

    if (normalized.includes('total task') || normalized.includes('total tasks')) {
      return AI_RESPONSE_LIBRARY['totalTasks'];
    }

    if (
      normalized.includes('priority chart') ||
      normalized.includes('distribution') ||
      normalized.includes('urgency')
    ) {
      return AI_RESPONSE_LIBRARY['priorityChart'];
    }

    if (normalized.includes('cld') && normalized.includes('jayesh')) {
      return AI_RESPONSE_LIBRARY['cldJayesh'];
    }

    if (
      normalized.includes('counts') ||
      normalized.includes('audited') ||
      normalized.includes('verified')
    ) {
      return AI_RESPONSE_LIBRARY['statusCounts'];
    }

    if (normalized.includes('security score')) {
      return AI_RESPONSE_LIBRARY['securityScore'];
    }

    return AI_RESPONSE_LIBRARY['default'];
  }

  private createAudit(query: string): AiPromptAudit {
    return {
      ...AI_AUDIT_PROMPT,
      userPrompt: query,
      payload: {
        ...AI_AUDIT_PROMPT.payload,
        query,
      },
    };
  }

  private nextId(prefix: string): string {
    this.sequence += 1;
    return `${prefix}-${Date.now()}-${this.sequence}`;
  }
}
